var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.cardContent.cardType === "color"
        ? [
            _c(
              "div",
              {
                class: `col-item card card-${_vm.cardContent.cardType} card-text-${_vm.cardContent.cardTextAlign}`,
                style: `background-color: ${_vm.cardContent.cardBackgroundColor.rgbaString}`,
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-content-body",
                    class: `card-content card-content-position-${_vm.cardContent.cardVerticalTextAlign}`,
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "title",
                        style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                      },
                      [_c("h3", [_vm._v(_vm._s(_vm.cardContent.cardTitle))])]
                    ),
                    _vm._v(" "),
                    _vm.cardContent.cardDescription
                      ? _c(
                          "div",
                          {
                            staticClass: "description",
                            style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.cardContent.cardDescription) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.cardContent.cardButtonPrimaryUrl &&
                      _vm.cardContent.cardButtonPrimaryText) ||
                    (_vm.cardContent.cardButtonSecondaryUrl &&
                      _vm.cardContent.cardButtonSecondaryText)
                      ? [
                          _c(
                            "div",
                            { staticClass: "card-actions" },
                            [
                              _vm.cardContent.cardButtonPrimaryUrl &&
                              _vm.cardContent.cardButtonPrimaryText
                                ? [
                                    _c(
                                      "generic-link",
                                      {
                                        staticClass: "btn btn-primary-cta",
                                        attrs: {
                                          target: _vm.primaryButtonTarget,
                                          href: _vm.cardContent
                                            .cardButtonPrimaryUrl,
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cardContent
                                                .cardButtonPrimaryText
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.cardContent.cardButtonSecondaryUrl &&
                              _vm.cardContent.cardButtonSecondaryText
                                ? [
                                    _c(
                                      "generic-link",
                                      {
                                        staticClass: "btn btn-secondary-cta",
                                        attrs: {
                                          target: _vm.secondaryButtonTarget,
                                          href: _vm.cardContent
                                            .cardButtonSecondaryUrl,
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cardContent
                                                .cardButtonSecondaryText
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      : _vm.cardContent.cardButtonPrimaryUrl
                      ? [
                          _c("generic-link", {
                            staticClass: "card-overlay-link",
                            attrs: {
                              target: _vm.primaryButtonTarget,
                              href: _vm.cardContent.cardButtonPrimaryUrl,
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.cardContent.cardType === "photo"
        ? [
            _c(
              "div",
              {
                class: `col-item card card-${_vm.cardContent.cardType} effect-image-scale card-text-${_vm.cardContent.cardTextAlign}`,
              },
              [
                _c(
                  "div",
                  { staticClass: "card-image" },
                  [
                    _c("AImage", {
                      attrs: {
                        img: _vm.cardContent.fileStore,
                        title: _vm.cardContent.cardTitle,
                        alt: _vm.cardContent.cardTitle,
                        preset: `grid-image-${_vm.gridSize}`,
                        responsive: "",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "image-overlay",
                  style: `opacity:${
                    _vm.cardContent.cardBackgroundTinting / 100
                  }`,
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card-content-body",
                    class: `card-content card-content-position-${_vm.cardContent.cardVerticalTextAlign}`,
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.cardContent.cardTitle))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.cardContent.cardDescription) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    (_vm.cardContent.cardButtonPrimaryUrl &&
                      _vm.cardContent.cardButtonPrimaryText) ||
                    (_vm.cardContent.cardButtonSecondaryUrl &&
                      _vm.cardContent.cardButtonSecondaryText)
                      ? [
                          _c(
                            "div",
                            { staticClass: "card-actions" },
                            [
                              _vm.cardContent.cardButtonPrimaryUrl &&
                              _vm.cardContent.cardButtonPrimaryText
                                ? [
                                    _c(
                                      "generic-link",
                                      {
                                        staticClass: "btn btn-primary-cta",
                                        attrs: {
                                          target: _vm.primaryButtonTarget,
                                          href: _vm.cardContent
                                            .cardButtonPrimaryUrl,
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cardContent
                                                .cardButtonPrimaryText
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.cardContent.cardButtonSecondaryUrl &&
                              _vm.cardContent.cardButtonSecondaryText
                                ? [
                                    _c(
                                      "generic-link",
                                      {
                                        staticClass: "btn btn-secondary-cta",
                                        attrs: {
                                          target: _vm.secondaryButtonTarget,
                                          href: _vm.cardContent
                                            .cardButtonSecondaryUrl,
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cardContent
                                                .cardButtonSecondaryText
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      : _vm.cardContent.cardButtonPrimaryUrl
                      ? [
                          _c("generic-link", {
                            staticClass: "card-overlay-link",
                            attrs: {
                              target: _vm.primaryButtonTarget,
                              href: _vm.cardContent.cardButtonPrimaryUrl,
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.cardContent.cardType === "icon"
        ? [
            _c(
              "div",
              {
                class: [
                  `col-item card card-${_vm.cardContent.cardType} card-text-${_vm.cardContent.cardTextAlign}`,
                  {
                    "card-text-center":
                      _vm.cardContent.cardIconPosition === "center",
                  },
                  {
                    "card-text-contained":
                      _vm.cardContent.cardIconPosition === "leftcontent",
                  },
                ],
                style: `background-color: ${_vm.cardContent.cardBackgroundColor.rgbaString}`,
              },
              [
                _c(
                  "div",
                  { staticClass: "card-content-body" },
                  [
                    _vm.cardContent.cardIconPosition === "left"
                      ? [
                          _c("div", { staticClass: "icon-header" }, [
                            _c(
                              "div",
                              { staticClass: "icon-container" },
                              [
                                _c("AImage", {
                                  staticClass: "svg-icon",
                                  class: {
                                    "drop-shadow":
                                      _vm.cardContent.cardIconDropShadow ===
                                      true,
                                  },
                                  attrs: {
                                    img: _vm.cardContent.fileStore,
                                    title: _vm.cardContent.cardTitle,
                                    alt: _vm.cardContent.cardTitle,
                                    preset: `grid-image-${_vm.gridSize}`,
                                    responsive: "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _c(
                                "h3",
                                {
                                  style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                                },
                                [_vm._v(_vm._s(_vm.cardContent.cardTitle))]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.cardContent.cardDescription
                            ? _c(
                                "div",
                                {
                                  staticClass: "description",
                                  style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.cardContent.cardDescription) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cardContent.cardIconPosition === "leftcontent"
                      ? [
                          _c("div", { staticClass: "icon-container" }, [
                            _c("img", {
                              staticClass: "svg-icon",
                              class: {
                                "drop-shadow":
                                  _vm.cardContent.cardIconDropShadow === true,
                              },
                              attrs: {
                                src: _vm.backgroundImageUrl,
                                alt: "Icon",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "icon-content" }, [
                            _c("div", { staticClass: "title" }, [
                              _c(
                                "h3",
                                {
                                  style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                                },
                                [_vm._v(_vm._s(_vm.cardContent.cardTitle))]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.cardContent.cardDescription
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "description",
                                    style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.cardContent.cardDescription
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cardContent.cardIconPosition === "center"
                      ? [
                          _c(
                            "div",
                            { staticClass: "icon-container text-center" },
                            [
                              _c("img", {
                                staticClass: "svg-icon",
                                class: {
                                  "drop-shadow":
                                    _vm.cardContent.cardIconDropShadow === true,
                                },
                                attrs: {
                                  src: _vm.backgroundImageUrl,
                                  alt: "Icon",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _c(
                              "h3",
                              {
                                style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.cardContent.cardTitle) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.cardContent.cardDescription
                            ? _c(
                                "div",
                                {
                                  staticClass: "description",
                                  style: `color: ${_vm.cardContent.cardTextColor.rgbaString}`,
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.cardContent.cardDescription) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                (_vm.cardContent.cardButtonPrimaryUrl &&
                  _vm.cardContent.cardButtonPrimaryText) ||
                (_vm.cardContent.cardButtonSecondaryUrl &&
                  _vm.cardContent.cardButtonSecondaryText)
                  ? [
                      _c("div", { staticClass: "card-content-footer" }, [
                        (_vm.cardContent.cardButtonPrimaryUrl &&
                          _vm.cardContent.cardButtonPrimaryText) ||
                        (_vm.cardContent.cardButtonSecondaryUrl &&
                          _vm.cardContent.cardButtonSecondaryText)
                          ? _c(
                              "div",
                              { staticClass: "card-actions" },
                              [
                                _vm.cardContent.cardButtonPrimaryUrl &&
                                _vm.cardContent.cardButtonPrimaryText
                                  ? [
                                      _c(
                                        "generic-link",
                                        {
                                          staticClass: "btn btn-primary-cta",
                                          attrs: {
                                            target: _vm.primaryButtonTarget,
                                            href: _vm.cardContent
                                              .cardButtonPrimaryUrl,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cardContent
                                                  .cardButtonPrimaryText
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.cardContent.cardButtonSecondaryUrl &&
                                _vm.cardContent.cardButtonSecondaryText
                                  ? [
                                      _c(
                                        "generic-link",
                                        {
                                          staticClass: "btn btn-secondary-cta",
                                          attrs: {
                                            target: _vm.secondaryButtonTarget,
                                            href: _vm.cardContent
                                              .cardButtonSecondaryUrl,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cardContent
                                                  .cardButtonSecondaryText
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  : _vm.cardContent.cardButtonPrimaryUrl
                  ? [
                      _c("generic-link", {
                        staticClass: "card-overlay-link",
                        attrs: {
                          target: _vm.primaryButtonTarget,
                          href: _vm.cardContent.cardButtonPrimaryUrl,
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.cardContent.cardType === "video"
        ? [
            _c(
              "div",
              { class: [`col-item card card-${_vm.cardContent.cardType}`] },
              [
                _c("iframe", {
                  attrs: {
                    src: `${_vm.cardContent.cardVideoUrl}?rel=0&controls=0&showinfo=0`,
                    width: "100%",
                    frameborder: "0",
                    allow: "autoplay; encrypted-media",
                    allowfullscreen: "",
                  },
                }),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.cardContent.cardType === "wysiwyg"
        ? [
            _c(
              "div",
              { class: [`col-item card card-${_vm.cardContent.cardType}`] },
              [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.sanitizedContent) },
                }),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }